/// <reference types="@capacitor-firebase/authentication" />

import { CapacitorConfig } from '@capacitor/cli';

const config: CapacitorConfig = {
  appId: 'com.llamandoaldoctor',
  appName: 'lad-pwa-patients',
  webDir: 'dist/lad-pwa-patients',
  ios: {
    contentInset: 'always',
    scheme: 'LAD'
  },
  plugins: {
    SplashScreen: {
      launchAutoHide: false,
      backgroundColor: '#29293B',
      splashImmersive: false,
      layoutName: 'splash_activity'
    },
    Keyboard: {
      resizeOnFullScreen: true
    },
    FirebaseAuthentication: {
      skipNativeAuth: false,
      providers: ['google.com', 'apple.com', 'microsoft.com']
    }
  },
  experimental: {
    ios: {
      spm: {
        packageOptions: {
          '@capacitor-firebase/authentication': {
            symlink: true
          }
        }
      }
    }
  }
};

export default config;
